import classNames from 'clsx';

const Container: React.FCC = ({ children, className }) => {
  return <div className={classNames('container mx-auto px-5', className)}>{children}</div>;
};

export default Container;
